import { render, staticRenderFns } from "./PlatformServices.vue?vue&type=template&id=232f2fc7&scoped=true&"
import script from "./PlatformServices.vue?vue&type=script&lang=js&"
export * from "./PlatformServices.vue?vue&type=script&lang=js&"
import style0 from "./PlatformServices.vue?vue&type=style&index=0&id=232f2fc7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232f2fc7",
  null
  
)

export default component.exports